export default "__VITE_ASSET__f7d45335__"